import { render, staticRenderFns } from "./BTable.vue?vue&type=template&id=17b6d62e&scoped=true&"
import script from "./BTable.vue?vue&type=script&lang=js&"
export * from "./BTable.vue?vue&type=script&lang=js&"
import style0 from "./BTable.vue?vue&type=style&index=0&id=17b6d62e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b6d62e",
  null
  
)

export default component.exports